import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SystemOverview from './topics/SupportDocTopics/SystemOverview';
import Installation from './topics/SupportDocTopics/Installation';
import MeasurementSettings from './topics/SupportDocTopics/MeasurementSettings';
import PriceMatrix from './topics/SupportDocTopics/PriceMatrix';
import Product from './topics/SupportDocTopics/Product';
import SmartInventory from './topics/SupportDocTopics/SmartInventory';
import User from './topics/SupportDocTopics/User';
import POSSales from './topics/SupportDocTopics/POSSales';
import PaymentTaxes from './topics/SupportDocTopics/PaymentTaxes';
import Admin from './topics/SupportDocTopics/Admin';
import Reports from './topics/SupportDocTopics/Reports';
import Scheduling from './topics/SupportDocTopics/Scheduling'
import ClockInClockOut from './topics/SupportDocTopics/ClockInClockOut';
import PinPad from './topics/SupportDocTopics/PinPad';
import CheckIn from './topics/SupportDocTopics/CheckIn';
import Twilio from './topics/SupportDocTopics/Twilio';
import Campaign from './topics/SupportDocTopics/Plugins/Campaign';
import WebMenu from './topics/SupportDocTopics/Plugins/WebMenu';
import BarCodeScan from './topics/SupportDocTopics/Troubleshooting/BarCodeScan';
import Hardware from './topics/SupportDocTopics/Troubleshooting/Hardware';
import General from './topics/SupportDocTopics/Troubleshooting/General';
import ProductTrouble from './topics/SupportDocTopics/Troubleshooting/ProductTrouble';
import UserTrouble from './topics/SupportDocTopics/Troubleshooting/UserTrouble';


const SupportDocument = () => {
    const location = useLocation();

    useEffect(() => {
        // This will scroll to the section when the hash is updated
        const hash = location.hash;
        if (hash) {
        const element = document.querySelector(hash);
        if (element) {
            element.scrollIntoView();
        }
        }
    }, [location]);

    return (
        <div className="SupportDocument">
            <SystemOverview />
            <Installation />
            <MeasurementSettings />
            <PriceMatrix />
            <Product />
            <SmartInventory />
            <User />
            <POSSales/>
            <PaymentTaxes />
            <Admin />
            <Reports />
            <Scheduling />
            <ClockInClockOut />
            <PinPad />
            <CheckIn />
            <Twilio />
            <Campaign />
            <WebMenu />
            <BarCodeScan />
            <Hardware />
            <General />
            <ProductTrouble />
            <UserTrouble />               
        </div>
    );
}

export default SupportDocument;